import { Lock, User } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginFormData } from "../types/LoginFormData";
import { useForm } from "react-hook-form";
import { loginSchema } from "../schemas/login.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useLogin } from "../hooks/Auth/useLogin";
import { loginApi } from "../services/admin/auth";

export const LoginForm = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const from = location.state?.from?.pathname || "/";
	const [serverError, setServerError] = useState("");
	const login = useLogin();

	const {
		register,
		handleSubmit,
		formState: { errors, isValid, isSubmitting },
	} = useForm<LoginFormData>({
		resolver: zodResolver(loginSchema),
		mode: "onChange",
	});

	const onSubmit = async (data: LoginFormData) => {
		try {
			try {
				const { token, user } = await loginApi(data.email, data.password);
				localStorage.setItem("discovery-auth-token", token);
				login(token, user);
			} catch (error) {
				console.error(error);
				throw new Error("Credenciais inválidas ou erro de conexão");
			}

			navigate(from, { replace: true });
		} catch (error) {
			setServerError("Email ou senha inválidos");
			console.error("Erro ao fazer login:", error);
		}
	};

	return (
		<div className="min-h-screen bg-gray-900 flex items-center justify-center">
			<div className="bg-gray-800 p-8 rounded-xl shadow-lg w-full max-w-md">
				<div className="flex justify-center mb-8">
					<img
						src="https://stoix.dev/images/logo.svg"
						alt="Stoix"
						className="h-8"
					/>
				</div>
				<h2 className="text-2xl font-bold text-white text-center mb-6">
					Stoix - Discovery 360º
				</h2>
				<form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
					<div>
						<div className="relative">
							<User
								size={20}
								className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
							/>
							<input
								type="text"
								{...register("email")}
								placeholder="Email"
								className="w-full pl-10 pr-4 py-2 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-colors"
							/>
							{errors.email && (
								<p className="text-red-500 text-sm text-center">
									{errors.email.message}
								</p>
							)}
						</div>
					</div>
					<div>
						<div className="relative">
							<Lock
								size={20}
								className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
							/>
							<input
								type="password"
								{...register("password")}
								placeholder="Senha"
								className="w-full pl-10 pr-4 py-2 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition-colors"
							/>
							{errors.password && (
								<p className="text-red-500 text-sm text-center">
									{errors.password.message}
								</p>
							)}
						</div>
					</div>
					{serverError && (
						<p className="text-red-500 text-sm text-center">{serverError}</p>
					)}
					<button
						type="submit"
						className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800 cursor-pointer
						disabled:opacity-50 disabled:cursor-not-allowed"
						disabled={!isValid || isSubmitting}
					>
						Entrar
					</button>
				</form>
			</div>
		</div>
	);
};
